// src/queries/getGalleryQuery.js
import { gql } from "@apollo/client";

export const GET_GALLERY_QUERY = gql`
  query GetGallery($tenantId: String!, $entityType: String!) {
    listLibraryCards(input: { tenantId: $tenantId, entityType: $entityType }) {
      tenantId
      entityType
      entityId
      payload
      createdAt
    }
  }
`;
